import * as React from "react";

const SvgAutomationsIcon = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={16} y={6} width={5} height={13} rx={1.08308} transform="rotate(90 16 6)" fill="#7D4CB5" /><rect x={21} y={13} width={5} height={13} rx={1.08308} transform="rotate(90 21 13)" fill="#C196F7" /></svg>;

export default SvgAutomationsIcon;